import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleModelService } from '../services/vehicle-model.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-modal-vehicle-edit',
  templateUrl: './modal-vehicle-edit.component.html',
  styleUrls: ['./modal-vehicle-edit.component.css'],
})
export class ModalVehicleEditComponent implements OnInit {
  @Input() selectedVehicle: any;
  @Output() close = new EventEmitter<void>();
  vehicleForm!: FormGroup;
  showModal: boolean = true;

  constructor(
    private fb: FormBuilder,
    private vehicleService: VehicleModelService,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.vehicleForm = this.fb.group({
      year: [this.selectedVehicle?.year, Validators.required],
      typevehicle: [this.selectedVehicle?.typevehicle, Validators.required],
      marca: [this.selectedVehicle?.marca, Validators.required],
      modelo: [this.selectedVehicle?.modelo, Validators.required],
      km: [this.selectedVehicle?.km, [Validators.required, Validators.min(0)]],
      plate: [this.selectedVehicle?.plate, Validators.required],
      city: [this.selectedVehicle?.city, Validators.required],
      color: [this.selectedVehicle?.color, Validators.required],
    });
  }
  ngOnChanges() {
    if (this.selectedVehicle) {
      console.log('Vehículo recibido en el modal:', this.selectedVehicle);
      this.vehicleForm = this.fb.group({
        year: [this.selectedVehicle.year],
        typevehicle: [this.selectedVehicle.typevehicle],
        marca: [this.selectedVehicle.marca],
        modelo: [this.selectedVehicle.modelo],
        km: [this.selectedVehicle.km],
        plate: [this.selectedVehicle.plate],
        city: [this.selectedVehicle.city],
        color: [this.selectedVehicle.color],
      });
    }
  }

  updateVehicle(): void {
    if (this.vehicleForm.invalid) return;

    this.vehicleService.updateVehicleModel(this.selectedVehicle._id, this.vehicleForm.value).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'Vehículo actualizado correctamente',
          confirmButtonText: 'Aceptar',
        }).then(() => {
          this.closeModal();
        });
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al actualizar el vehículo. Inténtalo de nuevo.',
          confirmButtonText: 'Cerrar',
        });
      },
    });
  }

  closeModal(): void {
    window.location.reload();
    this.close.emit();
  }
  selectColor(color: string): void {
    this.vehicleForm.get('color')?.setValue(color);
  }
}
